<template><div><h1>VUX V2.5.5 发布日志</h1>
<h2><a href="/zh-CN/components/actionsheet.html">Actionsheet</a></h2>
<ul><li>[feature] 支持在 on-click-menu 参数里附带原始 menu 对象 #1772</li>
</ul>
<h2><a href="/zh-CN/components/alert.html">Alert</a></h2>
<ul><li>[feature] 支持 hideOnBlur #1742</li>
</ul>
<h2><a href="/zh-CN/components/cell-box.html">CellBox</a></h2>
<ul><li>[change] 移除默认 slot 的父级 div #1769</li>
</ul>
<h2><a href="/zh-CN/components/confirm.html">Confirm</a></h2>
<ul><li>[feature] 支持方法 setInputValue 设置输入值 #1746</li>
</ul>
<h2><a href="/zh-CN/components/countup.html">Countup</a></h2>
<ul><li>[feature] 添加属性 tag 用以定义渲染标签 #1739</li>
</ul>
<h2><a href="/zh-CN/components/datetime.html">Datetime</a></h2>
<ul><li>[feature] 支持动态设置小时列表 #1749</li>
<li>[enhance] 更加流畅的遮罩层动画</li>
</ul>
<h2><a href="/zh-CN/components/inline-calendar.html">InlineCalendar</a></h2>
<ul><li>[feature] 支持多选 #1446 #1467</li>
</ul>
<h2><a href="/zh-CN/components/popup.html">Popup</a></h2>
<ul><li>[feature] 在 deactived 事件触发时自动关闭，避免在路由切换时依然显示弹窗，可以使用 prop:hide-on-deactivated 进行禁用 #1774</li>
</ul>
<h2><a href="/zh-CN/components/swipeout.html">Swipeout</a></h2>
<ul><li>[enhance] swipeout-item 新增 render 方法 #1688</li>
</ul>
<h2><a href="/zh-CN/components/tabbar.html">Tabbar</a></h2>
<ul><li>[feature] 支持 link 上使用 replace: true 写法 #1761</li>
</ul>
<h2><a href="/zh-CN/components/x-input.html">XInput</a></h2>
<ul><li>[feature] 为 on-focus on-blur 事件添加 $event 参数 #1770</li>
<li>[fix] 修复值为空的错误判断逻辑 #1759</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.5.5 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.5.5-247.vue?b629e422